import './FilterHistory.css';const filterHistory = "_filterHistory_10i9n_1";
const styles = {
  filterHistory
};
export {
  styles as default,
  filterHistory
};
